import { Link, useSearchParams } from "react-router-dom";
import { XCircle, ArrowLeft } from "lucide-react";

export default function PagamentoCancelado() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const back = token ? `/pagamento/${token}` : "/";
  return (
    <div className="min-h-screen flex items-center justify-center px-6 text-center bg-[#FAFAFA]" data-testid="pagto-cancelado">
      <div className="max-w-md">
        <XCircle className="w-16 h-16 text-amber-600 mx-auto mb-3" />
        <div className="font-heading text-2xl font-bold mb-2">Pagamento cancelado</div>
        <p className="text-zinc-500 mb-6 text-sm">Você pode tentar novamente a qualquer momento.</p>
        <Link to={back} data-testid="tentar-novamente" className="inline-flex items-center gap-2 px-4 py-2 rounded-md bbh-btn-primary text-sm font-semibold">
          <ArrowLeft className="w-4 h-4" /> Tentar novamente
        </Link>
      </div>
    </div>
  );
}
